import { Grid } from '@mui/material';
import React from 'react';
import ProfitLossGraphContainer from './ProfitLossGraphContainer';
import ActiveAccountGraphContainer from './ActiveAccountGraphContainer';

const GraphsContainer = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <ProfitLossGraphContainer />
      </Grid>
      <Grid item xs={12} sm={6}>
        <ActiveAccountGraphContainer />
      </Grid>
    </Grid>
  );
};

export default GraphsContainer;
